<template>
  <div class="class-list">
    <GlobalInfoBar
      title="平台商户账务"
      content="操作平台所有商户的上下账，查看上下账记录"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From :tabActive="tabActive"/>
      </div>
      <Table @tabChange="tabChange"/>
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {
      tabActive: "",
    };
  },
  methods: {
    tabChange(type){
      this.tabActive = type
    }
  },
};
</script>

<style>
</style>